/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductSheetDto = {
    readonly id?: string;
    productId: string;
    sheetId: string;
    productSheetState: ProductSheetDto.productSheetState;
    readonly sheetNumber?: string;
    readonly nameDe?: string;
    readonly nameEn?: string;
    readonly thirdPartyCertificateRequired?: boolean;
    readonly approvalReceivedAt?: string;
};
export namespace ProductSheetDto {
    export enum productSheetState {
        REQUESTED = 'REQUESTED',
        APPROVED = 'APPROVED',
        CANCELLED = 'CANCELLED',
        REJECTED = 'REJECTED',
        EXPIRED = 'EXPIRED',
        REWORK_NECESSARY = 'REWORK_NECESSARY',
    }
}

